/**
 * Çözüm Önerileri — manifesto ile tanımlanan ilk modül.
 *
 * Bu klasörü silmek özelliği tamamen kaldırır: core.js'te temizlenecek go()
 * dalı, index.html'de silinecek script etiketi, aranacak dağınık referans yok.
 * Geriye yalnızca kayıt listesinden bir satır çıkarmak kalır.
 */

import { defineFeature } from '../../shell/feature.ts';
import { render, teardown } from './render.ts';

export default defineFeature({
  id: 'solutions',
  label: 'Çözüm Önerileri',
  view: 'v2',

  mount: () => render(),
  unmount: () => teardown(),

  /**
   * Eski çekirdek hâlâ rSol()'u çağırıyor (core.js x2, finance.js x1).
   * Bu köprü onları çalışır tutuyor; o üç çağıran da göç edince silinecek.
   */
  legacyGlobals: { rSol: render },

  emits: ['solutions.viewed'],
});
